import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { MwCorePreferenceService } from '../preference.service';

@Injectable()
export class MwPreferenceLoadedGuard implements CanActivate, CanLoad {
  private readonly preferenceLoaded$ = this.preferenceService.preference$.pipe(
    filter((preference) => !!preference),
    map(() => true),
    take(1)
  );

  constructor(private readonly preferenceService: MwCorePreferenceService) {}
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.preferenceLoaded$;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.preferenceLoaded$;
  }
}
